//service contracts
import { GetEmailTokenResponse } from "@performyard/service-contracts";

import request from "./internal-base-request";

export const getEmailTokens = async (userId: string): Promise<GetEmailTokenResponse> => {
	const [response] = await request<GetEmailTokenResponse>(`/v1/email-token/${userId}`);
	return response;
};
